import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';

import BookingServices from '../../services/BookingServices';

function ViewCoupon({ coupon, closeModal }) {

  const [user, setUser] = useState(null);

  useEffect(() => {
    if (!coupon) return;
    const fetchInvestment = async () => {
      try {
        const response = await BookingServices.getBookingByCoupon(coupon._id);
        setUser(response.data);
        // console.log(response.data)
      } catch (error) {
        console.error('Error fetching user:', error);
      }
    };
    fetchInvestment();
  }, [coupon]);

 
  function formatDateTime(isoString) {
    const date = new Date(isoString);
    const formattedDate = date.toLocaleDateString();
    const formattedTime = date.toLocaleTimeString();
    return { date: formattedDate, time: formattedTime };
  }

  const formatDate = (dateString) => {
    const date = new Date(dateString);

    if (isNaN(date.getTime())) {
      return 'N/A';
    }

    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear().toString();

    return `${day}-${month}-${year}`;
  };



 

  if (!coupon) return null;

  return (
    <div className="modal fade viewbox edit-box show d-block" tabIndex={-1} aria-labelledby="userModal" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Details View</h5>
            <button type="button" className="btn-close" onClick={closeModal} aria-label="Close"></button>
          </div>
          <div className="modal-body">
            <div className="container">

              {/* Booking History Section */}
              <div className="booking-detail container-box user-manager" style={{ marginTop: '20px' }}>
                <h4>User Details</h4>
                <table className="table table-striped" style={{ border: '1px solid #FFFFFF', borderRadius: '10px' }}>
                  <thead style={{ backgroundColor: '#D9D9D9' }}>
                    <tr>
                      <th style={{ color: '#fff', backgroundColor: '#8C8FA7' }}>Booking ID</th>
                      <th style={{ color: '#fff', backgroundColor: '#8C8FA7' }}>User Name</th>
                      <th style={{ color: '#fff', backgroundColor: '#8C8FA7' }}>User Mobile</th>
                      <th style={{ color: '#fff', backgroundColor: '#8C8FA7' }}>User Email</th>
                      <th style={{ color: '#fff', backgroundColor: '#8C8FA7' }}>Cottage Name</th>
                      <th style={{ color: '#fff', backgroundColor: '#8C8FA7' }}> Date</th>
                      <th style={{ color: '#fff', backgroundColor: '#8C8FA7' }}>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                 
                    {user && user.length > 0 ? (
                      user.map((customer, index) => (
                        <tr key={index} style={{ backgroundColor: '#F9FAFF' }}>
                          <td className='bookingId'>#{customer?.bookingId || 'N/A'}</td>
                          <td>{customer?.user?.name || 'N/A'}</td>
                          <td>{customer?.user?.mobileNo || 'N/A'}</td>
                          <td>{customer?.user?.email || 'N/A'}</td>
                          <td>{customer?.cottage.name || 'N/A'}</td>
                          <td>{formatDate(customer?.createdAt) || 'N/A'}</td>
                          <td>{customer?.status || 'N/A'}</td>
                          
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7" style={{ textAlign: 'center' }}>
                          No Investment History Available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              
            </div>
          </div>
          <div className="modal-footer d-flex">
            <button type="button" className="site-btn-green" style={{ marginBlock: '15px' }} onClick={closeModal}>
              CLOSE
            </button>
          </div>
        </div>
      </div>
      
    </div>
  );
}

export default ViewCoupon;
